// -----------------------------------------------
// redirect.js
// リダイレクト用モジュール
// https://www2.uccard.co.jp/uc/platinum/?company_cd=パラメータ へリダイレクトさせる
// リダイレクトさせたくないパラメータを追加する場合は allowedParams 配列に追加する
// -----------------------------------------------
function init() {
  checkUrlParams();
}

function checkUrlParams() {
  const queryString = window.location.search; // 現在のURLのクエリ文字列
  // 許可するパラメータリスト
  const allowedParams = [
    '?company_cd=000532', // 広告無し（デフォルト）
    '?company_cd=000534', // Yahoo検索広告
    '?company_cd=000535', // Meta広告用
    '?company_cd=000536', // Google検索広告（SEM）
    '?company_cd=000537', // Pmax広告用（Google）
    '?company_cd=000543', // X広告用
    '?company_cd=000538', // Tiktok広告用
    '?company_cd=000539', // Yahoo! Display（YDN / yjad_conversion）
    '?company_cd=000540', // Eight Data x Meta
    '?company_cd=000533', // Meta FourM第三者配信
    '?company_cd=000541', // LINE広告用
    '?company_cd=000542', // Google RD（レスポンシブディスプレイ）
    '?company_cd=000507', // 価格.com広告用
  ];
  const redirectBase = 'https://www2.uccard.co.jp/uc/platinum/';

  const isAllowed = allowedParams.some(param => queryString.startsWith(param));
  if (!isAllowed) {
    // 許可されないパラメータや無しの場合のリダイレクト
    let redirectUrl = redirectBase;
    if (queryString && queryString.startsWith('?')) {
      redirectUrl += queryString;
    }
    window.location.href = redirectUrl;
    return; // この時点で処理終了
  }

  const companyCd = getCompanyCd(queryString);
  if (!companyCd) {
    return;
  }

  updateCompanyCdLink(document.querySelector('#js-lounge-link a'), companyCd);
  document.querySelectorAll('[data-company-cd-link]').forEach(link => {
    updateCompanyCdLink(link, companyCd);
  });
}

function getCompanyCd(queryString) {
  const params = new URLSearchParams(queryString);
  return params.get('company_cd');
}

function updateCompanyCdLink(link, companyCd) {
  if (!link || !companyCd) {
    return;
  }

  const url = new URL(link.href);
  url.searchParams.set('company_cd', companyCd);
  link.href = url.toString();
}


export default {
  init,
};